import React from "react";
import {Trans, useTranslation} from "react-i18next";
import {useDispatch, useSelector} from 'react-redux';
import _ from "lodash";
import moment from "moment";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import DateTimePicker from '@mui/lab/DateTimePicker';
import {
    DetailsAndRationaleLabels,
    DiscussionLabels,
    DNACPRData,
    DNACPROrderStatus,
    ImplantableCardioverter,
    MentalCapacityLabels,
    StepsMatrix,
} from "./dnacpr_data";
import {useStyles} from "./dnacpr_styles";
import uuidv4 from "uuid/v4";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import {patient} from "../../../../store/reducers/patient";
import {user} from "../../../../store/reducers/user";
import {Grid, TextField} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import * as _get from "lodash/get";
import * as _set from "lodash/set";
import Formatter from "../../../../util/formatter";
import IconButton from '@mui/material/IconButton';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import AgyleStepper from '../../inpatientForms/AgyleStepper';
import AgyleBlockSwitch from '../../../../components/ui/switch/agyleBlockSwitch';
import InformationBox from '../../../../components/other/informationBox';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import AgyleDatePicker from '../../../../components/ui/fields/agyleDatePicker';

function InlineFormDNACPR(props) {
    //editMode Component
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const patientObject = useSelector(patient);
    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    const formBase = {
        id: uuidv4() + '',
        name: "DNACPR_order",
        patientId: patientObject.hospitalNumber,
        createDate: moment(),
        status: DNACPROrderStatus.AVAITING,
        createBy: tester,
        createById: userObject.__id,
        signedBy: null,
        signedById: null,
        signedDate: null,
        canceledDate: null,
        canceledBy: null,
        canceledById: null,
        canceledReason: "",
        ...DNACPRData.getFormBaseData()
    }
    const authorBase = {
        name: "DNACPR_author",
        ...DNACPRData.getFormBaseData()
    }
    const debaterBase = {
        id: uuidv4() + "",
        name: "",
        role: ""
    }
    const [activeStep, setActiveStep] = React.useState(0);
    const [nextDisabled, setNextDisabled] = React.useState(false);
    const [form, setForm] = React.useState(formBase);
    const [authors, setAuthors] = React.useState(authorBase);
    const [debator, setDebator] = React.useState(debaterBase);
    const steps = DNACPRData.getStates();
    const dicts = {
        mentalCapacity: MentalCapacityLabels,
        detailsAndRationale: DetailsAndRationaleLabels,
        discussion: DiscussionLabels,
        implantableCardioverter: ImplantableCardioverter
    }

    const dispatch = useDispatch();

    const handleNext = () => {
        if(activeStep < steps.length - 1) {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        } else {
            //dispatch(setDNACPR(form));
           // dispatch(addDNACPR(form));

            props.onSave(form)
            props.closeForm();
        }
    };

    const handlePrev = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleClose = () => {
        props.closeForm();
    }

    const handleChangeAnswer = (question, group, qCount, event )=> {
        let key = question + "value";
        let qSarr = question.split("");
        let qIndex = parseInt(qSarr.splice(1,qSarr.length - 1).join(""));
        let formTmp = {...form};
        formTmp[group][key] = event;
        if(group == "mentalCapacity") {
            for(qIndex++; qIndex < qCount; qIndex++){
                formTmp[group]["q" + qIndex + "value"] = null;
            }
        }
        setForm(formTmp);
    }

    const getLastUpdateText  = (field) => {
        return _get(authors,field)? "Last updated by " + _get(authors,field): null
    }

    const onPropChange = (prop, eventValue, useValue) => {
        return (event, value) => {
            const data = { ...form};
            if (eventValue) {
                _set(data, prop, event);
            } else {
                if (useValue) {
                    _set(data, prop, value);
                } else {
                    _set(data, prop, event.target.value);
                }
            }
            setForm(data);
            let authorNew = { ...authors};
            _set(authorNew, prop, tester + " @ " + moment().format("DD/MM/YYYY HH:mm:ss"));
            setAuthors(authorNew);
            setNextDisabled(checkNextBtnEnabled());
        };
    }

    const mentalCapacityQuestionary = () => {
        let formRows = [];
        let subMatrix = ["q0"]
        let buildMatrix = ["q0"];
        while(subMatrix.length > 0) {
            subMatrix.forEach((questionaryPart) => {
                if(questionaryPart.substring(0,1) == "q"){
                    let key = questionaryPart + "value";
                    if (form.mentalCapacity[key] != null) {
                        if (form.mentalCapacity[key] == "y") {
                            subMatrix = StepsMatrix[questionaryPart]["y"];
                        } else {
                            subMatrix = StepsMatrix[questionaryPart]["n"];
                        }
                    } else {
                        subMatrix = [];
                    }
                }
            });
            buildMatrix.push(...subMatrix)
        }
        buildMatrix.forEach((qPart) => {
            switch(qPart.substring(0,1)){
                case "q":
                    formRows.push(...createQuestion('mentalCapacity', qPart));
                    break;
                case "i":
                    formRows.push(...createInfoBlock('mentalCapacity', qPart));
                    break;
                case "l":
                    formRows.push(...createInputTextBlock('mentalCapacity', qPart));
                    break;
            }
        })

        return formRows;
    }

    const createQuestion = (group, i) => {
        let key = i + "value";
        let questions = [];
        questions.push(
            <Grid item xs={10} key={group + "_" + i + "_question"} className={classes.questionLabel}>
                { t(dicts[group]["questions"][i]) }
            </Grid>
        );
        questions.push(<Grid item key={group + "_" + i + "_value"}>
            <AgyleBlockSwitch
                onChange={handleChangeAnswer.bind(this, i, group, Object.keys(dicts[group]["questions"]).length)}
                value={form[group][key]}
                valueObject={{
                    false: 'n',
                    true: 'y'
                }}
            />
        </Grid>);
        questions.push(<Grid item xs={12} key={group + "_" + i + "_d"} style={{borderBottom: "1px solid #626466"}}></Grid>);
        return questions;
    }

    const createInfoBlock = (group, key) => {
        if(!Array.isArray(key)) {
            key = [key];
        }

        return [
        <Grid item xs={12} key={key[0] + "_info"}>
            <InformationBox type="info" fullWidth>
                { key.map((elKey) => {
                    //Used Trans because of issue with colon sign!!!
                    return (<div key={group + "_info-block_" + elKey}><Trans>{dicts[group]['infos'][elKey]}</Trans></div>)
                }) }
            </InformationBox>
        </Grid>]
    }

    const createInputTextBlock = (group, key) => {
        return [
            <Grid item xs={12} key={key + "_text"}>
                <div className={classes.inputlabel}>{ t(dicts[group]['labels'][key]) }</div>
                <AgyleTextField
                    value={form[group][key + "value"]}
                    onChange={onPropChange(group + "."+ key + "value]")}
                    size="small"
                    textFieldClass={classes.input}
                    helperText={getLastUpdateText(group + "." + key + "value")}
                    fullWidth
                />
            </Grid>
        ];
    }

    //discussion debaters
    const debatersBlock = (withEdit) => {
       return (
           <>

               <Grid item xs={5}>
                   <div className={classes.inputlabel}> {t("Name")}</div>
                   <AgyleTextField
                       value={debator.name}
                       onChange={onTextChange("name")}
                       size="small"
                       textFieldClass={classes.input}
                       fullWidth
                   />
               </Grid>
               <Grid item xs={5}>
                   <div className={classes.inputlabel}> {t("Relationship/Role")}</div>
                   <AgyleTextField
                       value={debator.role}
                       onChange={onTextChange("role")}
                       size="small"
                       textFieldClass={classes.input}
                       fullWidth
                   />
               </Grid>
               <Grid item xs={2}>
                   <div className={classes.inputlabel}/>
                   <AgyleButton width={"100%"} variant="contained" color="primary"   onClick={addDebater}>
                       {t('Insert')}
                   </AgyleButton>
               </Grid>
               { getDebaters(true) }
           </>
       )
    }

    const getDebaters = (removable) => {
        if(form.discussion.debaters.length > 0) {
            let debaters = [
            ];
            form.discussion.debaters.forEach((debater) =>{
                debaters.push(
                    <>
                        <Grid item xs={5}>
                            { debater.name }
                        </Grid>
                        <Grid item xs={5}>
                            { debater.role }
                        </Grid>
                        <Grid item xs={2}>
                            {removable &&
                                <AgyleButton width={"100%"} colour="error" variant={"contained"} onClick={removeDebater.bind(this, debater.id)}>
                                    {t('Remove')}
                                </AgyleButton>
                            }
                        </Grid>
                    </>
                );
            });
            return debaters;
        } else return "";
    }

    const onTextChange = (prop, eventValue, useValue) => {
        return (event, value) => {
            const data = {...debator};
            if (eventValue) {
                _set(data, prop, event);
            } else {
                if (useValue) {
                    _set(data, prop, value);
                } else {
                    _set(data, prop, event.target.value);
                }
            }
            setDebator(data);
        };
    }

    const addDebater = () => {
        const data = { ...form};
        data.discussion.debaters.push({...debator});
        const d = {...debaterBase}
        d.id = uuidv4() + "";
        setDebator(d);
        setForm(data);
    }

    const removeDebater = (debId) => {
        let data = {...form};
        _.remove(data.discussion.debaters, function(debater) {
            return debater.id === debId;
        });
        setForm(data);
    }
    // end debaters

    // form steppers
    const checkNextBtnEnabled = () => {
        let nextBtnDisabled = false;
        switch(activeStep){
            case 0:
                let subMatrix = ["q0"];
                let allRadioChecked = true;
                let textInserted = form.mentalCapacity.l0value && form.mentalCapacity.l0value.length > 0;
                while(subMatrix.length > 0) {
                    subMatrix.forEach((questionaryPart) => {
                        if(questionaryPart.substring(0,1) == "q"){
                            let key = questionaryPart + "value";
                            if (form.mentalCapacity[key] != null) {
                                if (form.mentalCapacity[key] == "y") {
                                    subMatrix = StepsMatrix[questionaryPart]["y"];
                                } else {
                                    subMatrix = StepsMatrix[questionaryPart]["n"];
                                }
                            } else {
                                subMatrix = [];
                                allRadioChecked = false;
                            }
                        }
                    });
                }
                if(form.mentalCapacity.q5value == 'n'){
                    nextBtnDisabled = !(textInserted && allRadioChecked);
                } else {
                    nextBtnDisabled = !allRadioChecked;
                }
                break;
            case 1:
                let validCondition = form.detailsAndRationale.validUntil != null && moment().isBefore(form.detailsAndRationale.validUntil);
                let descTextInserted = form.detailsAndRationale.description && form.detailsAndRationale.description.length > 0;
                nextBtnDisabled = !(validCondition && descTextInserted);
                break;
            case 2:
                let allRadioChecked2 = form.discussion.q0value != null;
                let debaterExists = true;
                if(form.discussion.q0value != null && form.discussion.q0value === "y"){
                    debaterExists = form.discussion.discussionDoctor.length > 0 && form.discussion.discussionDate != null;
                }
                let explainExists = true;
                if(form.discussion.q0value != null && form.discussion.q0value === "n"){
                    debaterExists = form.discussion.l0value.length > 0;
                }
                nextBtnDisabled = !(allRadioChecked2 && debaterExists && explainExists);
                break;
            case 3:
                let allRadioChecked3 = form.implantableCardioverter.q0value != null
                    && form.implantableCardioverter.q1value != null
                    && form.implantableCardioverter.q2value != null;
                let deactivateDate = form.implantableCardioverter.q1value === "n" || form.detailsAndRationale.deactivateDate == null;
                nextBtnDisabled = !(allRadioChecked3 && deactivateDate);
                break;
        }
        return nextBtnDisabled;
    }

    let prevBtn;
    if(activeStep > 0) {
        prevBtn = <Button
            variant="contained"
            color="primary"
            className={classes.buttonNext}
            onClick={handlePrev}>
            {t('Previous')}
        </Button>
    }

    React.useEffect(()=> {
        setNextDisabled(checkNextBtnEnabled());
    }, [form])

    React.useEffect(()=> {
        setNextDisabled(checkNextBtnEnabled());
    }, [activeStep])

    const renderStepper = () => {

        return <div className={classes.modalHeader}>
            <AgyleStepper steps={steps} activeStep={activeStep} handleStep={()=>{}} />
        </div>
    }

    return (
        <div>
            <div className={classes.topBar}>
                <div className={classes.flexDiv}>
                    <IconButton
                        variant="contained"
                        color="inherit"
                        size={"small"}
                        onClick={props.closeForm}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <div className={classes.formName}> {t('DNA CPR Order')}</div>
                </div>

                <div>
                    {activeStep > 0 &&
                    <AgyleButton
                        size="small"
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={handlePrev}
                    >
                        Prev
                    </AgyleButton>
                    }

                    <AgyleButton
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={nextDisabled}
                        className={classes.button}
                        onClick={handleNext}
                    >
                        {activeStep === steps.length - 1 ? t('Finish') : t('Next')}
                    </AgyleButton>
                </div>
            </div>

            <div className={classes.formContainer}>
                {renderStepper()}
                <div className={classes.modalBody}>
                    {activeStep === 0 &&
                    <Grid container  spacing={1} justifyContent={"space-between"} className={classes.containerGrid}>
                        {mentalCapacityQuestionary()}
                    </Grid>
                    }
                    {activeStep === 1 &&
                    <Grid container spacing={1} justifyContent={"space-between"} className={classes.containerGrid}>
                        {createInfoBlock("detailsAndRationale", "i0")}
                        <Grid item xs={5}>
                            <div className={classes.inputlabel}>
                                {t('Valid until/Review Date')}
                            </div>
                            <div className={[classes.inlineFormBlock].join(" ")}>
                                <AgyleDatePicker
                                    type="date"
                                    disableFuture={false}
                                    textFieldClass={classes.input}
                                    value={form.detailsAndRationale.validUntil}
                                    onChange={onPropChange('detailsAndRationale.validUntil', true)}
                                />

                            </div>
                        </Grid>
                        {createInfoBlock("detailsAndRationale", ["i1", "i2", "i3", "i4", "i5"])}
                        <Grid item xs={12}>
                            <div className={classes.inputlabel}> {t("Details")}</div>
                            <AgyleTextField
                                value={form.detailsAndRationale.description}
                                onChange={onPropChange("detailsAndRationale.description")}
                                size="small"
                                multiline
                                minRows={4}
                                textFieldClass={classes.input}
                                helperText={getLastUpdateText("detailsAndRationale.description")}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                    }
                    {activeStep === 2 &&
                    <Grid container spacing={1} justifyContent={"space-between"} className={classes.containerGrid}>
                        {createInfoBlock("discussion", "i0")}
                        {createQuestion('discussion', "q0")}
                        {(form.discussion.q0value && form.discussion.q0value === "y") &&

                            <Grid item xs={12}>
                                <Grid container alignItems={"flex-end"} spacing={1} justifyContent={"space-between"} >

                                        {debatersBlock(true)}

                                    <Grid item xs={6}>
                                        <div className={classes.inputlabel}> {t("Discussion with patient led by")}</div>
                                        <AgyleTextField
                                            value={form.discussion.discussionDoctor}
                                            onChange={onPropChange("discussion.discussionDoctor")}
                                            size="small"
                                            textFieldClass={classes.input}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <div className={classes.inputlabel}> {t("Date")}</div>
                                        <AgyleDatePicker
                                            type="date"
                                            textFieldClass={classes.input}
                                            value={form.discussion.discussionDate}
                                            onChange={onPropChange('discussion.discussionDate', true)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        {(form.discussion.q0value && form.discussion.q0value === "n") &&
                        <Grid item xs={12}>
                            <Grid container spacing={1} justifyContent={"space-between"} >
                                {createInfoBlock("discussion", "i1")}
                                {createInputTextBlock('discussion', "l0")}
                            </Grid>
                        </Grid>
                        }
                    </Grid>
                    }
                    {activeStep === 3 &&
                    <Grid container spacing={1} justifyContent={"space-between"} className={classes.containerGrid}>
                        {createQuestion('implantableCardioverter', "q0")}
                        {createQuestion('implantableCardioverter', "q1")}
                        <Grid item xs={5}>
                            <div className={classes.inlineFormBlock}>

                            </div>
                            <div className={classes.inputlabel}>  {t('Date deactivated')}</div>
                            <div className={[classes.inlineFormBlock].join(" ")}>
                                <AgyleDatePicker
                                    type="date"
                                    disableFuture={false}
                                    textFieldClass={classes.input}
                                    value={form.implantableCardioverter.deactivateDate}
                                    onChange={onPropChange('implantableCardioverter.deactivateDate', true)}
                                />
                            </div>
                        </Grid>
                        {createQuestion('implantableCardioverter', "q2")}
                    </Grid>
                    }
                </div>
            </div>


        </div>
    );
}

export default InlineFormDNACPR;
